var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid meeting-agenda" },
    [
      _vm.loaders.agendas
        ? _c(
            "div",
            { staticClass: "loading-indicator" },
            [_c("MoonLoader", { attrs: { size: "75px", color: "#ffffff" } })],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("MeetingAgendasContainer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "grid" }, [
      _c(
        "div",
        { staticClass: "grid__col--12 meeting-agenda__title h-center-align" },
        [_vm._v("Meeting Agendas")]
      )
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }